import React from "react";
import useApiEp from "../hooks/useApiEp";
import { Alert, Box, Typography, Paper, useTheme } from "@mui/material";
import { getErrorResponse } from "../utils/util";
import MuPb from "../widgets/MuPb";

const LeadsStats = () => {
  const { data, isLoading, isError, error } = useApiEp(
    `/message/get-message-sender-stats`
  );

  if (isLoading) {
    return <MuPb />;
  }

  if (isError) {
    return <Alert severity="error">{getErrorResponse(error)}</Alert>;
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography
        variant="h4"
        component="h1"
        gutterBottom
        sx={{
          fontWeight: "bold",
          mb: 4,
          color: "primary.main",
          textAlign: "center",
        }}
      >
        Top Message Senders
      </Typography>

      <Box sx={{ maxWidth: 800, mx: "auto" }}>
        {data.map((sender, index) => (
          <SenderRow
            key={sender.customerId}
            rank={index + 1}
            sender={sender}
            isHighlighted={index < 3}
          />
        ))}
      </Box>
    </Box>
  );
};

const SenderRow = ({ rank, sender, isHighlighted }) => {
  const theme = useTheme();

  // Format the count number with commas
  const formattedCount = sender.count.toLocaleString();

  return (
    <Paper
      elevation={isHighlighted ? 3 : 1}
      sx={{
        display: "flex",
        alignItems: "center",
        p: 2,
        mb: 2,
        borderRadius: 2,
        background: isHighlighted
          ? `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`
          : theme.palette.background.paper,
        color: isHighlighted ? "white" : "inherit",
        transition: "all 0.2s ease",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: 4,
        },
      }}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: isHighlighted ? "white" : theme.palette.primary.main,
          color: isHighlighted ? theme.palette.primary.main : "white",
          fontWeight: "bold",
          fontSize: "1.2rem",
          mr: 3,
          flexShrink: 0,
        }}
      >
        {rank}
      </Box>

      <Box sx={{ flexGrow: 1, overflow: "hidden" }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: isHighlighted ? "bold" : "medium",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {sender.customerId}
        </Typography>
      </Box>

      <Box
        sx={{
          backgroundColor: isHighlighted ? "rgba(255,255,255,0.2)" : "grey.100",
          px: 2,
          py: 1,
          borderRadius: 1,
          minWidth: 100,
          textAlign: "center",
        }}
      >
        <Typography
          variant="body1"
          sx={{
            fontWeight: "bold",
            color: isHighlighted ? "white" : "primary.main",
          }}
        >
          {formattedCount}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: isHighlighted ? "rgba(255,255,255,0.8)" : "text.secondary",
          }}
        >
          messages
        </Typography>
      </Box>
    </Paper>
  );
};

export default LeadsStats;
